// Module
var code = `<label class="struct-entry">
    <a class="struct-name" href> </a>
    <div class="struct-metadata">
        (<span class="struct-alloc-num"> </span> allocations)
    </div>
    <input type="checkbox" checked>
</label>
<div class="struct-alloc"></div>`;
// Exports
export default code;